module.exports={
	"Form": "TestViewManifest",
	"Scope": "Test-View",
	"Descriptors":
	{
		"TestDetails.Name":
		{
			"Name": "Name",
			"Hash": "Test-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "Test-View-Identity",
				"Group": "Test-View-Identity"
			}
		},
		"TestDetails.Description":
		{
			"Name": "Description",
			"Hash": "Test-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 12,
				"Section": "Test-View-Details",
				"Group": "Test-View-Details"
			}
		},
		"TestDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "Test-View-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "Test-View-Details",
				"Group": "Test-View-Details"
			}
		},
		"TestDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "Test-View-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 12,
				"Section": "Test-View-Details",
				"Group": "Test-View-Details"
			}
		},
		"TestDetails.Active":
		{
			"Name": "Active",
			"Hash": "Test-View-Active",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "Test-View-Details",
				"Group": "Test-View-Details"
			}
		},
		"TestDetails.Standalone":
		{
			"Name": "Standalone",
			"Hash": "Test-View-Standalone",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "Test-View-Details",
				"Group": "Test-View-Details"
			}
		},
		"TestDetails.Injectable":
		{
			"Name": "Injectable",
			"Hash": "Test-View-Injectable",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "Test-View-Details",
				"Group": "Test-View-Details"
			}
		},
		"TestDetails.Collection":
		{
			"Name": "Collection",
			"Hash": "Test-View-Collection",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "Test-View-Details",
				"Group": "Test-View-Details"
			}
		},
		"TestDetails.SmallQuantityExempt":
		{
			"Name": "Small Quantity Exempt",
			"Hash": "Test-View-SmallQuantityExempt",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "6",
				"Width": 3,
				"Section": "Test-View-Details",
				"Group": "Test-View-Details"
			}
		},
		"TestDetails.IDTest":
		{
			"Name": "IDTest",
			"Hash": "Test-View-IDTest",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Test-View-DataAudit",
				"Group": "Test-View-DataAudit"
			}
		},
		"TestDetails.GUIDTest":
		{
			"Name": "GUIDTest",
			"Hash": "Test-View-GUIDTest",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Test-View-DataAudit",
				"Group": "Test-View-DataAudit"
			}
		},
		"TestDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Test-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Test-View-DataAudit",
				"Group": "Test-View-DataAudit"
			}
		},
		"TestDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Test-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Test-View-DataAudit",
				"Group": "Test-View-DataAudit"
			}
		},
		"TestDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Test-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Test-View-DataAudit",
				"Group": "Test-View-DataAudit"
			}
		},
		"TestDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Test-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Test-View-DataAudit",
				"Group": "Test-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Test-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Test-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Test-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Test-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Test-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Test-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
